<template>
    <transition name="overlayFade">
        <div v-if="open"
             class="fixed inset-0 overflow-hidden z-50"
             data-cy="slide-over">
            <Keypress key-event="keyup" :key-code="27" @success="$emit('close')" />
            <div class="absolute inset-0 overflow-hidden">
                <transition name="overlayFade">
                    <div
                        @click="$emit('close')"
                        v-if="open"
                        class="absolute inset-0 bg-gray-500 bg-opacity-75 transition-all transform"
                    ></div>
                </transition>
                <section
                    :class="['absolute', 'inset-y-0', 'right-0', 'pl-10', 'max-w-full', 'flex', fullWidth ? 'w-full' : null]"
                >
                    <transition name="slide">
                        <div v-if="open" :class="['relative', 'w-screen', fullWidth ? 'max-w-full' : 'max-w-xl']">
                            <transition name="fade">
                                <div

                                    v-if="open"
                                    class="absolute top-0 left-0 -ml-8 pt-4 pr-2 flex sm:-ml-10 sm:pr-4"
                                >
                                    <button
                                        @click.prevent="$emit('close')"
                                        type="button"
                                        aria-label="Close panel"
                                        class="text-gray-300 hover:text-white transition ease-in-out duration-150"
                                    >
                                        <svg
                                            class="h-6 w-6"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M6 18L18 6M6 6l12 12"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </transition>
                            <div
                                class="h-full flex flex-col space-y-6 py-6 bg-white dark:bg-gray-800 shadow-xl overflow-y-scroll"
                            >
                                <div class="relative flex-1 px-4 sm:px-6">
                                    <div class="absolute inset-0 px-4 sm:px-6">
                                        <component
                                            :empty-message="emptyMessage"
                                            :linkable-types="contentTypes"
                                            :follow-redirects="false"
                                            :full-width="fullWidth"
                                            :show-select-all="showSelectAll"
                                            :language="language"
                                            :languageData="language"
                                            :is="component"
                                            :label="label"
                                            :formName="formName"
                                            :model="model"
                                            :data="object"
                                            :excluded-ids="excludedIds"
                                            :excluded-documents="excludedDocuments"
                                            :selected="selected"
                                            :selected-objects="selectedObjects"
                                            :multiple="multiple"
                                            @created="objectCreated"
                                            @selected="objectSelected"
                                            :submit-via-ajax="true"
                                            :form-route="formRoute"
                                            :list-route="listRoute"
                                            @deselect-all="$emit('deselect-all')"
                                            @select-all="(selectAllObjects) => $emit('select-all', selectAllObjects)"
                                            @list-loaded="(listCount) => $emit('list-loaded', listCount)"
                                            :list-data="listData"
                                            :max-items="maxItems"
                                            :query="query"
                                            :order="order"
                                            :pre-filled="preFilled"
                                            :with-docs="withDocs"
                                            :parent="parent"
                                            :is-slide-over="true"
                                            :index="index"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </section>
            </div>
        </div>
    </transition>
</template>
<script>
export default {
    name: "SlideOver",
    components: {
      Keypress: () => import('vue-keypress')
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        emptyMessage: {
            type: String,
            required: false
        },
        fullWidth: {
            type: Boolean,
            default: false,
        },
        showSelectAll: {
            type: Boolean,
            default: false,
        },
        formRoute: {
            type: String,
            required: false,
        },
        listRoute: {
            type: String,
            required: false,
        },
        maxItems: Number,
        excludedIds: {
            type: Array,
            required: false,
        },
        excludedDocuments: {
            type: Array,
            required: false
        },
        model: {
            type: String,
        },
        component: {
            type: String,
        },
        formName: String,
        multiple: {
            type: Boolean,
        },
        selected: {
            type: Array,
            default: () => [],
        },
        selectedObjects: {
            type: Array,
            default: () => [],
        },
        label: String,
        routeKeyName: String,
        object: Object,
        language: Object,
        query: Object,
        order: Object,
        contentTypes: Array,
        listData: Array,
        preFilled: {
            type: Object,
            required: false,
        },
        withDocs: {
            type: Array,
            required: false
        },
        parent: Object,
        index: Boolean | null,
    },
    data() {
        return {
            open: this.isOpen,
        };
    },
    methods: {
        objectCreated(object) {
            this.$emit("created", { object, component: this.component });
        },
        objectSelected(object) {
            this.$emit("selected", { object, component: this.component });
        },
    },
    watch: {
        isOpen(isOpen) {
            this.open = isOpen;
        },
    },
};
</script>
